<div>
  <app-breadcrumb></app-breadcrumb>
</div>

<mat-card>
    <mat-card-content>
      <div class="table-header">
        <h2>Liste des documents</h2>
      </div>
  
      <mat-divider></mat-divider>

      <form [formGroup]="filter">
        <mat-form-field appearance="outline" class="general-filter">
            <mat-label><mat-icon>search</mat-icon>Liste des documents</mat-label>
            <input type="text" placeholder="Mnémonique, titre, document .."  matInput formControlName="general_filter">
            @if(filter.controls['general_filter'].value) {
                <mat-icon matSuffix mat-icon-button (click)="clearGeneralFilter()" >close</mat-icon>
            }
        </mat-form-field>
      </form>
  
      <div class="mat-elevation-z8">
        <mat-table [dataSource]="dataSource" matSort>
  
          <ng-container matColumnDef="mnemonique">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Mnémonique</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.mnemonique }}</mat-cell>
          </ng-container>
  
          <ng-container matColumnDef="titre">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Titre</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.titre }}</mat-cell>
          </ng-container>
          
          <ng-container matColumnDef="createdAt">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Date de soumission</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.createdAt | date:'dd/MM/yyyy' }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="fileName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Document</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.annexes[0].fileName }}</mat-cell>
          </ng-container>
  
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
            <mat-cell *matCellDef="let element">
                <mat-icon (click)="openDocumentViewDialog(element)">visibility</mat-icon>
            </mat-cell>
          </ng-container>
  
          <div class="no-data" *matNoDataRow>
            <b>Aucun document</b>
          </div>
  
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  
        </mat-table>
  
        <mat-paginator [pageSizeOptions]="[10, 15, 20]"
                       aria-label="Select page of periodic elements"
                       showFirstLastButtons>
        </mat-paginator>
      </div>
  
    </mat-card-content>
  </mat-card>
